// CLAUDE-SYNC: v1.7.12 (2026-09-02) — PWA install support for ReyaGoWeb.
// Adapted from Create React App's standard service-worker registration
// helper. Registers public/service-worker.js so the app can be "Added to
// Home Screen" on phones/tablets and opens as a standalone app.
//
// IMPORTANT: service workers only register on localhost or over HTTPS
// (browser platform requirement, not something this code enforces). If
// staging is served over plain HTTP, registration will silently no-op there
// — install/offline support won't be testable until staging has HTTPS. This
// was flagged as an open dependency when PWA support was scoped.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production') return; // don't fight CRA's dev server / hot reload
  if (!('serviceWorker' in navigator)) return;

  const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
  if (publicUrl.origin !== window.location.origin) return; // CDN-hosted PUBLIC_URL — SW can't control that scope

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New content is available; the next reload picks it up.
              console.log('ReyaGo: new version available — will load on next refresh.');
              if (config && config.onUpdate) config.onUpdate(registration);
            } else {
              console.log('ReyaGo: app is ready for offline use.');
              if (config && config.onSuccess) config.onSuccess(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      console.warn('ReyaGo: service worker registration failed:', error?.message);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('ReyaGo: no internet connection — running in offline mode.');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error.message));
}
